<template>
  <FormModal :title="headTitle" show-back-btn>
    <template #body>
      <ExecutionPeriodFormStep :progress-value="progressValue" />
    </template>
  </FormModal>
</template>

<script>
import FormModal from 'chimera/all/themes/blueflow/components/layout/FormModal'
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import { useExperiments } from 'chimera/all/composables/useExperiments'
import { PD_10118_REMOVE_PAINTING_QUESTIONS } from 'chimera/all/constants/experiments'
import ExecutionPeriodFormStep from '~/components/form/steps/executionPeriod/ExecutionPeriodFormStep.vue'

export default {
  components: {
    ExecutionPeriodFormStep,
    FormModal,
  },

  extends: AbstractFormPage,

  layout: 'form',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Wanneer wil je jouw project uitvoeren?',
      headDescription: 'Wanneer wil je jouw project uitvoeren?',
      path: '/offertes-aanvragen/uitvoeringsperiode',
    }
  },

  computed: {
    /**
     * @returns {boolean}
     */
    isVariantFlow() {
      const { getFromStore, isVariant } = useExperiments(this.$store)
      return isVariant(getFromStore(PD_10118_REMOVE_PAINTING_QUESTIONS), 1)
    },

    /**
     * @returns {number}
     */
    progressValue() {
      return this.isVariantFlow ? 25 : 34
    },
  },

  /**
   * Set checkoutStep based on experiment variant.
   */
  mounted() {
    this.setCheckoutStep(this.isVariantFlow ? 1 : 2)
  },
}
</script>
